import { render, staticRenderFns } from "./VCategory.vue?vue&type=template&id=2ce143fb"
import script from "./VCategory.vue?vue&type=script&lang=ts"
export * from "./VCategory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports